import React, { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  Collapse,
  IconButton,
} from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import { ReorderRecommendations } from '@thd-olt-component-react/thd-recs-containers';

const REORDER_RECOMMENDATIONS_REQUEST_KEY = 'purchase-history';

// Best-effort reserved height for the pre-mount placeholder below, so the
// card doesn't pop in from zero height once it mounts. Tuned against the
// common "has items" case; other content states (e.g. the empty-results
// fallback) can render at a different height and will still shift by
// whatever that delta turns out to be — this mitigates CLS, it doesn't
// eliminate it. Re-measure if the card's typical content changes.
const PRE_MOUNT_RESERVED_HEIGHT = '437px';

export const ReorderRecommendationsSection = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  // ReorderRecommendations relies on store-localization state (useStore) that
  // isn't guaranteed to match between SSR and the first client render, so the
  // whole card is deferred until after mount rather than hydration-mismatching.
  // Pre-mount we reserve its footprint with a plain, static div — no dynamic
  // classes or context reads — so it hydrates identically on server and
  // client while still avoiding the zero-height pop-in that drove CLS.
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return (
      <div
        className="sui-w-full"
        style={{ minHeight: PRE_MOUNT_RESERVED_HEIGHT }}
      />
    );
  }

  return (
    <div className="sui-w-full sui-flex-grow">
      <Card
        initialSize="full"
        className="!sui-rounded-[6px] sui-flex sui-h-full"
      >
        <div className="sui-flex sui-flex-col sui-w-full">
          <div className="sui-relative sui-flex sui-items-center">
            <Typography
              variant="h3"
              className={isExpanded ? undefined : 'sui-w-full sui-text-center'}
            >
              Buy It Again
            </Typography>
            <div className="sui-absolute sui-right-0 sui-top-1/2 sui--translate-y-1/2">
              <IconButton
                onClick={() => setIsExpanded((prev) => !prev)}
                icon={isExpanded ? ArrowUp : ArrowDown}
                aria-label={
                  isExpanded ? 'Collapse Buy It Again' : 'Expand Buy It Again'
                }
                data-testid="buy-it-again-toggle"
              />
            </div>
          </div>
          <Collapse in={isExpanded}>
            <div className="sui-mt-4">
              <ReorderRecommendations
                requestKey={REORDER_RECOMMENDATIONS_REQUEST_KEY}
                hideTitle
                showLoading
                showFallback
              />
            </div>
          </Collapse>
        </div>
      </Card>
    </div>
  );
};

ReorderRecommendationsSection.dataModel = ReorderRecommendations.dataModel;
